import {useEffect} from 'react'

const useOnBeforeUnload = (onBeforeUnload: () => void) => {
  useEffect(() => {
    global.addEventListener('beforeunload', onBeforeUnload, false)

    return () => global.removeEventListener('beforeunload', onBeforeUnload, false)
  }, [])
}

export default useOnBeforeUnload
